import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./CourseLessonProgressMarker.module.scss";

export interface ICourseLessonProgressMarkerProps {
  difficultyCategory?: string,
  isCompleted?: boolean,
  displayIndex: number,
  paddingPercentWidth: number;
  displayPercentWidth: number;
  lessonNumber?: string,
}

export const CourseLessonProgressMarker: VoidFunctionComponent<ICourseLessonProgressMarkerProps> = ({isCompleted, difficultyCategory, displayIndex, paddingPercentWidth, displayPercentWidth, lessonNumber}) => {

  const paddingPercentBeforeDisplay = displayIndex * paddingPercentWidth;
  const rectPercentBeforeDisplay = !displayIndex ? 0 : (displayIndex * displayPercentWidth);
  const startPositionPercent = paddingPercentBeforeDisplay + rectPercentBeforeDisplay;

  const difficultyClass = s[`${difficultyCategory}`];
  const completionClass = (isCompleted ? `${s.lessonComplete}` : `${s.lessonIncomplete}`);
  const useClassNames = [difficultyClass, completionClass].join(' ');

  // Adjust vertical position of marker based on completion status
  // SVG coordinates start from top left
  const yPos = isCompleted ? 10 : 0;
  // Shorter markers for completed lessons
  const markerHeight = isCompleted ? 20 : 30;
  // Set corner rounding of the rectangle
  const cornerRadius = 2;

  return (
    <rect
      className={useClassNames}
      x={`${startPositionPercent}%`}
      y={yPos}
      width={`${displayPercentWidth}%`}
      height={markerHeight}
      rx={cornerRadius}
    >
      <title>Lesson {lessonNumber ?? `---`} {isCompleted ? 'complete' : 'incomplete'}</title>
    </rect>
  );
}

